import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./PlaylistCoverArt.module.css";

function PlaylistCoverArt({ thumbnails, overflowCount, className }) {
  const normalizedThumbnails = (thumbnails || []).filter(Boolean);
  // Trust the explicit overflowCount from the caller
  const effectiveOverflow = overflowCount;
  const hasOverflow = effectiveOverflow > 0;
  const visibleThumbnails = hasOverflow
    ? normalizedThumbnails.slice(0, 3)
    : normalizedThumbnails.slice(0, 4);
  const slots = Array.from(
    { length: 4 },
    (_, index) => visibleThumbnails[index] || null,
  );

  return (
    <div
      className={classNames(styles.root, className)}
      aria-label="Playlist cover art"
      role="img"
    >
      {slots.map((thumbnail, index) => {
        const isOverflowTile = hasOverflow && index === 3;

        return (
          <div
            key={`playlist-cover-tile-${index}`}
            className={isOverflowTile ? styles.overflowTile : styles.tile}
          >
            {isOverflowTile ? (
              <span className={styles.overflowText}>+{effectiveOverflow}</span>
            ) : thumbnail ? (
              <img
                src={thumbnail}
                alt={`Playlist media thumbnail ${index + 1}`}
                className={styles.thumbnail}
              />
            ) : null}
            {!isOverflowTile && !thumbnail ? (
              <span className={styles.placeholderTile} aria-hidden="true" />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

PlaylistCoverArt.propTypes = {
  thumbnails: PropTypes.arrayOf(PropTypes.string),
  overflowCount: PropTypes.number,
  className: PropTypes.string,
};

PlaylistCoverArt.defaultProps = {
  thumbnails: [],
  overflowCount: 0,
  className: "",
};

export default PlaylistCoverArt;
